const NoneErrorFallback = () => {
  return <span />;
};

export default NoneErrorFallback;
